<div class="card border-0">
  <div class="card-header">
    <div class="card-title">
      {{ consulta.decisaoCerta ? consulta.nomeConsulta : 'RESUMO'}}
    </div>
  </div>
  <div class="container-consultas">
    <div class="print-c">

      <div class="row" *ngIf="resumoVeiculo == true">
        <div class="col-12 col-print-6" *ngIf="veiculoSucess == true" [ngClass]="{'col-lg-6': consultaSuccess == true}">
          <div class="subtitle">
            VEÍCULO
          </div>
          <div class="d-flex d-print-flex py-2">
            <img *ngIf="marcaFipe == true"
              src="https://s3-sa-east-1.amazonaws.com/siteunion/LAUDO/resources/marcas/{{consulta?.dadosResumo?.marcaFipe}}.png"
              class="marca-veiculo-img mr-2 mr-lg-0" alt="">
            <div class="row">
              <div class="col-12 col-sm col-print-7 px-2" *ngIf="marcaModelo == true">
                <div class="text-secondary f-12 format-compacta">MARCA / MODELO:</div>
                <div class="text-uppercase format-compacta">{{consulta?.dadosResumo?.marcaVeiculo}} /
                  {{consulta?.dadosResumo?.modeloVeiculo}}</div>
              </div>
              <div class="col-12 col-sm-5 col-print-5 px-2" *ngIf="anoModelo == true">
                <div class="text-secondary f-12 format-compacta">FABRICAÇÃO / MODELO:</div>
                <div class="format-compacta">{{consulta?.dadosResumo?.anoFabricacao}} /
                  {{consulta?.dadosResumo?.anoModelo}}</div>
              </div>
              <div class="col-12 col-sm-7 col-print-7 px-2" *ngIf="emplacamento == true">
                <div class="text-secondary f-12  format-compacta">EMPLACAMENTO:</div>
                <div class="text-uppercase format-compacta">{{consulta?.dadosResumo?.municipio}} - {{consulta?.dadosResumo?.uf}}</div>
              </div>
              <div class="col-12 col-sm-5 col-print-5 px-2" *ngIf="cor == true">
                <div class="text-secondary f-12 format-compacta">COR:</div>
                <div class="text-uppercase format-compacta">{{consulta?.dadosResumo?.cor}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-print-6 pl-lg-3" *ngIf="consultaSuccess == true"
          [ngClass]="{'col-lg-6': veiculoSucess == true}">
          <div class="subtitle">
            DADOS DA CONSULTA
          </div>
          <div class="row">
            <div class="px-2 pt-2 col-12 col-sm-6 col-print-6">
              <div class="text-secondary f-12 format-compacta">ENTRADA:</div>
              <div class="text-uppercase format-compacta">{{ entrada || consulta?.placaEntrada || consulta?.chassiEntrada || consulta?.motorEntrada || consulta?.crlvEntrada || consulta?.cnhEntrada || consulta?.renavamEntrada || consulta?.documentoEntrada ||'NÃO INFORMADO'}}</div>
            </div>
            <div class="px-2 pt-2 col-12 col-sm-6 col-print-6" *ngIf="dataCriacao == true">
              <div class="text-secondary f-12 format-compacta">DATA DA REALIZAÇÃO DA CONSULTA:</div>
              <div class="format-compacta">{{ consulta?.dataCriacao }}</div>
              <!-- <div *ngIf="consulta.decisaoCerta" class="format-compacta">{{ consulta?.dataCriacao }}</div>
              <div *ngIf="!consulta.decisaoCerta" class="format-compacta">{{ consulta?.dataCriacao | date:'dd/MM/yyyy HH:mm' }}</div> -->
            </div>
            <div class="px-2 pt-2 col-12 col-sm-6 col-print-6" *ngIf="usuario == true">
              <div class="text-secondary f-12 format-compacta">USUÁRIO:</div>
              <div class="text-uppercase format-compacta">{{consulta?.usuario}}</div>
            </div>
            <div class="px-2 pt-2 col-12 col-sm-6 col-print-6" *ngIf="unidade == true">
              <div class="text-secondary f-12 format-compacta">SOLICITADO POR:</div>
              <div class="text-uppercase format-compacta">{{consulta?.unidade}}</div>
            </div>
            <div class="px-2 pt-2 col-12" *ngIf="id == true">
              <div class="text-secondary f-12 format-compacta">CÓDIGO DA CONSULTA:</div>
              <div class="format-compacta">{{consulta?.id}}</div>
            </div>
            <div class="px-2 pt-2 col-12" *ngIf="tokenconsulta == true">
              <div class="text-secondary f-12 format-compacta">TOKEN DA CONSULTA:</div>
              <div class="format-compacta">{{consulta?.tokenConsulta}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="consulta.decisaoCerta" class="w-100">
      <div class="subtitle">
        ANÁLISE DE MERCADO
      </div>
      <div class="d-flex flex-column flex-md-row">
        <div class="pt-2 mr-lg-3">
          <img class="analise-mercado-img" src="{{consulta?.dadosResumo?.fotoModelo}}">
          <div class="text-center text-italic text-muted py-2">
            <i>* FOTO ILUSTRATIVA</i>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-5 p-2">
            <div class="text-secondary f-12 format-compacta">DESCRIÇÃO MARCA / MODELO FIPE:</div>
            <div class="text-uppercase format-compacta">{{consulta?.dadosResumo?.marcaFipe}} /
              {{consulta?.dadosResumo?.modeloFipe}}</div>
          </div>
          <div class="col-12 col-lg-7">
            <div class="row">
              <div class="p-2 col-6">
                <div class="text-secondary f-12 format-compacta">
                  PREÇO FIPE:
                </div>
                <div class="format-compacta">
                  {{ consulta?.dadosResumo?.precoFipe | appCurrency:'R$' }}
                </div>
              </div>
              <div class="p-2 col-6">
                <div class="text-secondary f-12 format-compacta">
                  PREÇO MERCADO BR:
                </div>
                <div class="format-compacta">
                  {{ consulta?.dadosResumo?.precoMedioBr | appCurrency:'R$' }}
                </div>
              </div>
              <div class="p-2 col-6">
                <div class="text-secondary f-12 format-compacta">
                  PREÇO MERCADO FINANCEIRO:
                </div>
                <div class="format-compacta">
                  {{ consulta?.dadosResumo?.precoMolicar | appCurrency:'R$' }}
                </div>
              </div>
              <div class="p-2 col-6">
                <div class="text-secondary f-12 format-compacta">
                  PREÇO MERCADO {{consulta?.dadosResumo?.uf | appCurrency:'R$'}}:
                </div>
                <div class="format-compacta">
                  {{ consulta?.dadosResumo?.precoMedioUf | appCurrency:'R$' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-lg-3 col-print-3 col-6 py-2 p-sm-2 d-flex align-items-end print-c">
          <div class="hex" [ngClass]="{'bg-success': !totalRestricoes, 'bg-danger': totalRestricoes}">
            {{consulta?.dadosResumo?.qtdRestricoes}}</div>
          <div class="fw-500 px-1" [ngClass]="{'text-success': !totalRestricoes, 'text-danger': totalRestricoes}">
            RESTRIÇÕES</div>
        </div>
        <div class="col-lg-3 col-print-3 col-sm-6 py-2 p-sm-2 d-flex align-items-end print-c">
          <div class="hex" [ngClass]="{'bg-success': !totalMultas, 'bg-warning': totalMultas}">
            {{consulta?.dadosResumo?.qtdMultas}}</div>
          <div class="fw-500 px-1" [ngClass]="{'text-success': !totalMultas, 'text-warning': totalMultas}">MULTAS</div>
        </div>
        <div class="col-lg-3 col-print-3 col-sm-6 py-2 p-sm-2 d-flex align-items-end print-c">
          <div class="hex" [ngClass]="{'bg-success': !totalDebitos, 'bg-warning': totalDebitos}">
            {{consulta?.dadosResumo?.qtdDebitos}}</div>
          <div class="fw-500 px-1" [ngClass]="{'text-success': !totalDebitos, 'text-warning': totalDebitos}">DÉBITOS
          </div>
        </div>
        <div class="col-lg-3 col-print-3 col-sm-6 py-2 p-sm-2 d-flex align-items-end print-c">
          <div class="hex" [ngClass]="{'bg-success': !totalAtencoes, 'bg-warning': totalAtencoes}">
            {{consulta?.dadosResumo?.qtdPontosAtencao}}</div>
          <div class="fw-500 px-1" [ngClass]="{'text-success': !totalAtencoes, 'text-warning': totalAtencoes}">PONTOS DE
            ATENÇÃO</div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showItensResumo">
      <div class="print-c">
        <div class="card card-success">
          <div class="card-header">
            <div class="card-title-icon"></div>
            <h2 class="card-title">ITENS APROVADOS</h2>
            <div *ngIf="!itensAprovados?.length" class="card-msg bg-o-success text-success text-center fw-500">
              NÃO HÁ ITENS
            </div>
            <ul *ngIf="itensAprovados?.length" class="card-list card-list-success">
              <li *ngFor="let i of itensAprovados">
                <span [innerHTML]="i.label"></span><span class="fw-500 text-uppercase text-success"
                  [innerHTML]="i.value"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="print-c">
        <div class="card card-warning">
          <div class="card-header">
            <div class="card-title-icon"></div>
            <h2 class="card-title">ITENS ALERTAS</h2>
            <div *ngIf="!itensAlertas?.length" class="card-msg bg-o-warning text-warning text-center fw-500">
              NÃO HÁ ITENS
            </div>
          </div>
          <ul *ngIf="itensAlertas?.length" class="card-list card-list-warning">
            <li *ngFor="let i of itensAlertas">
              <span [innerHTML]="i.label"></span><span class="fw-500 text-uppercase text-warning"
                [innerHTML]="i.value"></span>
            </li>
          </ul>
        </div>
      </div>
      <div class="print-c">
        <div class="card card-danger">
          <div class="card-header">
            <div class="card-title-icon"></div>
            <h2 class="card-title">ITENS DE RESTRIÇÃO</h2>
            <div *ngIf="!itensReprovados?.length" class="card-msg bg-o-danger text-danger text-center fw-500">
              NÃO HÁ ITENS
            </div>
          </div>
          <ul *ngIf="itensReprovados?.length" class="card-list card-list-danger">
            <li *ngFor="let i of itensReprovados">
              <span [innerHTML]="i.label"></span><span class="fw-500 text-uppercase text-danger"
                [innerHTML]="i.value"></span>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>
</div>
